import { halfCirclePath } from '@labradorsports/utils';

import { FieldLogo } from '../../components/index.js';
import { getFieldPaddingPixelRect } from '../../utils/index.js';
import Court from '../icons/Court.js';

const HighSchoolFullFieldBackdrop: FC<any> = ({ fieldViewport, backgroundImage, viewOptions }) => {
    const fieldWidth = 50;
    const fieldHeight = 84;
    const fieldX = fieldViewport.flippedX ? fieldViewport.getPixelX(fieldWidth) : fieldViewport.getPixelX(0);
    const fieldY = fieldViewport.flipped ? fieldViewport.getPixelY(fieldHeight) : fieldViewport.getPixelY(0);
    const fieldPixelWidth = fieldViewport.getPixelLength(fieldWidth);
    const fieldPixelHeight = fieldViewport.getPixelLength(fieldHeight);
    const paddingRect = getFieldPaddingPixelRect(fieldViewport);

    return (
        <g className="field-backdrop">
            {viewOptions?.realField ? (
                <foreignObject
                    className="court-floor-background"
                    x={paddingRect.x}
                    y={paddingRect.y}
                    width={paddingRect.width}
                    height={paddingRect.height}
                >
                    <div
                        className="court-floor-background__fill"
                        style={{ borderRadius: paddingRect.cornerRadius }}
                    >
                        <Court
                            className="court-floor-background__court"
                            preserveAspectRatio="xMidYMid slice"
                            aria-hidden
                        />
                    </div>
                </foreignObject>
            ) : null}
            {/* Field Outline */}
            <rect x={fieldX} y={fieldY} width={fieldPixelWidth} height={fieldPixelHeight} fill="none" />

            {/* Top Logos */}
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: 8, y: 32 }}
                size={12}
                rotation={90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: fieldWidth - 8, y: 32 }}
                size={12}
                rotation={-90}
            />

            {/* Bottom Logos */}
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: 8, y: fieldHeight - 32 }}
                size={12}
                rotation={90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: fieldWidth - 8, y: fieldHeight - 32 }}
                size={12}
                rotation={-90}
            />

            {/* Bottom free throw lines */}
            <line
                x1={fieldViewport.getPixelX(19)}
                y1={fieldViewport.getPixelY(fieldHeight - 19)}
                x2={fieldViewport.getPixelX(19)}
                y2={fieldViewport.getPixelY(fieldHeight)}
            />
            <line
                x1={fieldViewport.getPixelX(19)}
                y1={fieldViewport.getPixelY(fieldHeight - 19)}
                x2={fieldViewport.getPixelX(fieldWidth - 19)}
                y2={fieldViewport.getPixelY(fieldHeight - 19)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth - 19)}
                y1={fieldViewport.getPixelY(fieldHeight - 19)}
                x2={fieldViewport.getPixelX(fieldWidth - 19)}
                y2={fieldViewport.getPixelY(fieldHeight)}
            />
            <path
                fill="none"
                d={halfCirclePath(
                    fieldViewport.getPixelLength(6),
                    fieldViewport.flippedX ? fieldViewport.getPixelX(fieldWidth - 19) : fieldViewport.getPixelX(19),
                    fieldViewport.getPixelY(fieldHeight - 19),
                    fieldViewport.flipped
                )}
            />

            {/* Top free throw lines */}
            <line
                x1={fieldViewport.getPixelX(19)}
                y1={fieldViewport.getPixelY(19)}
                x2={fieldViewport.getPixelX(19)}
                y2={fieldViewport.getPixelY(0)}
            />
            <line
                x1={fieldViewport.getPixelX(19)}
                y1={fieldViewport.getPixelY(19)}
                x2={fieldViewport.getPixelX(fieldWidth - 19)}
                y2={fieldViewport.getPixelY(19)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth - 19)}
                y1={fieldViewport.getPixelY(19)}
                x2={fieldViewport.getPixelX(fieldWidth - 19)}
                y2={fieldViewport.getPixelY(0)}
            />
            <path
                fill="none"
                d={halfCirclePath(
                    fieldViewport.getPixelLength(6),
                    fieldViewport.flippedX ? fieldViewport.getPixelX(fieldWidth - 19) : fieldViewport.getPixelX(19),
                    fieldViewport.getPixelY(19),
                    !fieldViewport.flipped
                )}
            />

            {/* Bottom 3 point line */}
            <path
                fill="none"
                d={halfCirclePath(
                    fieldViewport.getPixelLength(fieldWidth / 2 - 5.25),
                    fieldViewport.flippedX ? fieldViewport.getPixelX(fieldWidth - 5.25) : fieldViewport.getPixelX(5.25),
                    fieldViewport.getPixelY(fieldHeight - 5.3),
                    fieldViewport.flipped
                )}
            />
            <line
                x1={fieldViewport.getPixelX(5.25)}
                y1={fieldViewport.getPixelY(fieldHeight - 5.3)}
                x2={fieldViewport.getPixelX(5.25)}
                y2={fieldViewport.getPixelY(fieldHeight)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth - 5.25)}
                y1={fieldViewport.getPixelY(fieldHeight - 5.3)}
                x2={fieldViewport.getPixelX(fieldWidth - 5.25)}
                y2={fieldViewport.getPixelY(fieldHeight)}
            />

            {/* Top 3 point line */}
            <path
                fill="none"
                d={halfCirclePath(
                    fieldViewport.getPixelLength(fieldWidth / 2 - 5.25),
                    fieldViewport.flippedX ? fieldViewport.getPixelX(fieldWidth - 5.25) : fieldViewport.getPixelX(5.25),
                    fieldViewport.getPixelY(5.3),
                    !fieldViewport.flipped
                )}
            />
            <line
                x1={fieldViewport.getPixelX(5.25)}
                y1={fieldViewport.getPixelY(5.3)}
                x2={fieldViewport.getPixelX(5.25)}
                y2={fieldViewport.getPixelY(0)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth - 5.25)}
                y1={fieldViewport.getPixelY(5.3)}
                x2={fieldViewport.getPixelX(fieldWidth - 5.25)}
                y2={fieldViewport.getPixelY(0)}
            />

            {/* Center lines */}
            <circle
                cx={fieldViewport.getPixelX(fieldWidth / 2)}
                cy={fieldViewport.getPixelY(fieldHeight / 2)}
                r={fieldViewport.getPixelLength(6)}
                fill="none"
            />
            <line
                x1={fieldViewport.getPixelX(0)}
                y1={fieldViewport.getPixelY(fieldHeight / 2)}
                x2={fieldViewport.getPixelX(fieldWidth)}
                y2={fieldViewport.getPixelY(fieldHeight / 2)}
            />

            {/* Bottom substitution area */}
            <line
                x1={fieldViewport.getPixelX(fieldWidth - 3)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 + 19)}
                x2={fieldViewport.getPixelX(fieldWidth + 3)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 + 19)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 + 4)}
                x2={fieldViewport.getPixelX(fieldWidth + 3)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 + 4)}
            />

            {/* Top substitution area */}
            <line
                x1={fieldViewport.getPixelX(fieldWidth - 3)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 - 19)}
                x2={fieldViewport.getPixelX(fieldWidth + 3)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 - 19)}
            />
            <line
                x1={fieldViewport.getPixelX(fieldWidth)}
                y1={fieldViewport.getPixelY(fieldHeight / 2 - 4)}
                x2={fieldViewport.getPixelX(fieldWidth + 3)}
                y2={fieldViewport.getPixelY(fieldHeight / 2 - 4)}
            />

            <text
                dx={
                    fieldViewport.flippedX
                        ? fieldViewport.getPixelX(5.25) - 5
                        : fieldViewport.getPixelX(fieldWidth - 5.25) - 5
                }
                dy={fieldViewport.flipped ? fieldViewport.getPixelY(0) - 5 : fieldViewport.getPixelY(fieldHeight) - 5}
                textAnchor="end"
                strokeWidth="0"
                fill="#aaa"
                fontSize=".8em"
            >
                Hoops-Lab.com
            </text>
        </g>
    );
};

export default HighSchoolFullFieldBackdrop;
